export default __webpack_public_path__ + "static/media/accvSelected.765c229a.svg";